export default Object.freeze({
  Start: "start",
  Loading: "loading",
  Success: "success",
  Error: "error",
});
